<script>
import getUserLocale from 'get-user-locale';
export default {
  mounted() {
    if(this.$store.state.user) {
      let token = localStorage.getItem('token');
      let locale = localStorage.getItem('locale');
      if (!locale) {
        locale = getUserLocale().split('-')[0];
      }
      let lang = locale === 'vi' ? 'vi' : 'en_US';
      if(token) {
        location.href = `https://support.callio.vn/login.php?lang=${lang}&token=${token}`;
      }
    }
  },
}
</script>
